// @/utils/pdfInvoiceGenerator.js

import colors from "vuetify/lib/util/colors";

/**
 * PDF Invoice Generator Utility
 * ใช้สำหรับสร้าง PDF Invoice/Statement ด้วย pdfMake
 */

// ลบบรรทัดนี้ออก
// import logo from '../assets/logo.png';

class PDFInvoiceGenerator {
  constructor() {
    this.datavote = null;
    this.lg_vote_pdf_dialog = null;
    this.logoBase64 = null; // เพิ่มตัวแปรเก็บ logo
  }

  /**
   * โหลด logo เป็น Base64
   */
  async loadLogo() {
    try {
      const response = await fetch('/logo.png'); // ไฟล์ใน public folder
      const blob = await response.blob();
      
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.logoBase64 = reader.result;
          resolve(this.logoBase64);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('Error loading logo:', error);
      return null;
    }
  }

  formatDateTimeGMT(dateString) {
  if (!dateString) return "";
  
  const date = new Date(dateString);
  
  // เดือนแบบย่อภาษาอังกฤษ
  const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 
                  'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  
  // เวลาในรูปแบบ HH:MM
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  
  return `${day} ${month} ${year}, ${hours}:${minutes} (GMT+7)`;
}

 getTopVotedTexts(data) {
   if (!data || !data.length) return "";

  // กรองเฉพาะที่ votes.length > 0 ก่อน
  const validItems = data.filter(
    item => Array.isArray(item.votes) && item.votes.length > 0
  );

  if (!validItems.length) return "";

  // หา max votes
  const maxVotes = Math.max(...validItems.map(item => item.votes.length));

  // เอาเฉพาะที่เท่ากับ max
  return validItems
    .filter(item => item.votes.length === maxVotes)
    .map(item => item.text)
    .join(",");
}

   generateYAxisLabels(values) {
  const maxValue = Math.max(...values, 10);
  const chartHeight = 150;
  const labels = [];
  
  for (let i = 10; i >= 0; i--) {
    const y = ((10 - i) * chartHeight) / 10;
    
    labels.push({
      text: `${Math.round((i * maxValue) / 10)}`,
      fontSize: 8,
      alignment: 'left',
      absolutePosition: { x:45, y: y + 312 }, // ปรับ x, y ตามตำแหน่งจริง
      margin: [0, 0, 0, 0]
    });
  }
  
  return labels;
}

// ฟังก์ชันสร้าง X-axis labels
generateXAxisLabels(months, values) {
    const chartWidth = 480;
  const spacing = chartWidth / months.length;
  return months.map((month,i) => ({
    width: spacing,
    text: `${month} (${values[i].toFixed(0)})`,
    fontSize: 7,
    alignment: 'center'
  }));
}

// ฟังก์ชันสร้าง canvas สำหรับแท่งกราฟและ grid เท่านั้น
generateBarChartCanvas(months, values) {
const maxValue = Math.max(...values, 10);
  const chartHeight = 150;
  const chartWidth = 480;
  const maxBarWidth = 70; // กำหนดความกว้างสูงสุดของแท่ง
  const calculatedBarWidth = (chartWidth / months.length) - 8;
  const barWidth = Math.min(calculatedBarWidth, maxBarWidth); // เลือกค่าที่น้อยกว่า
  const spacing = (chartWidth / months.length); // ระยะห่างระหว่างแท่ง (ใช้ค่าเดิม)
  const baseY = chartHeight;
const colors = [
  "#EF5350", 
  "#42A5F5", 
  "#66BB6A", 
  "#FFA726", 
  "#AB47BC", 
  "#26C6DA", 
  "#FFCA28", 
  "#8D6E63", 
  "#EC407A", 
  "#7E57C2"  
];

  let canvas = [];

  // วาด Grid Lines แนวนอน
  for (let i = 0; i <= 10; i++) {
    const y = (chartHeight / 10) * (10 - i);
    
    canvas.push({
      type: 'line',
      x1: 0,
      y1: y,
      x2: chartWidth,
      y2: y,
      lineWidth: 0.5,
      lineColor: '#e0e0e0'
    });
  }

  // วาดแท่งกราฟ
  months.forEach((month, i) => {
    const barHeight = (values[i] / maxValue) * chartHeight;
    const centerX = i * spacing + (spacing / 2); // หาจุดกึ่งกลางของตำแหน่ง
    const x = centerX - (barWidth / 2); // วางแท่งให้อยู่กึ่งกลาง
    const y = baseY - barHeight;

    canvas.push({
      type: 'rect',
      x: x,
      y: y,
      w: barWidth,
      h: barHeight,
     color: colors[i]
    });
  });
  
  return canvas;
}

 prepareChartData(data) {
   const filtered = data.filter(({ text }) => text);

  return {
    months: filtered.map(item => item.text),
    values: filtered.map(item => item.count)
  };
}

  /**
   * ฟังก์ชันหลักสำหรับ Export PDF
   * @param {Object} invoiceData - ข้อมูล Invoice ที่ต้องการ Export
   * @returns {Promise<boolean>}
   */
  async exportToPDF(votedata,lg_vote_pdf_dialog_data) {
    try {
      // เก็บข้อมูลไว้
      this.datavote = votedata;
      this.lg_vote_pdf_dialog = lg_vote_pdf_dialog_data;
      this.setshowdata = null;

      // โหลด logo ก่อน
      await this.loadLogo();

      // รอให้ pdfMake พร้อมใช้งาน
      await this.waitForPdfMakeReady();

      // สร้าง PDF
      const docDefinition = this.generateCombinedDocDefinitionForInvoice();

      // เปิด PDF ใหม่ในแท็บใหม่
      pdfMake.createPdf(docDefinition).open();

      console.log("✅ สร้าง PDF สำเร็จ");
      return true;
    } catch (error) {
      console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
      throw error;
    }
  }

  /**
   * รอให้ pdfMake พร้อมใช้งาน
   * @returns {Promise<boolean>}
   */
  waitForPdfMakeReady() {
    return new Promise((resolve, reject) => {
      const checkInterval = setInterval(() => {
        if (typeof pdfMake !== "undefined" && pdfMake.vfs && pdfMake.fonts) {
          clearInterval(checkInterval);
          console.log("✅ pdfMake พร้อมใช้งาน พร้อมฟอนต์ภาษาไทย");
          resolve(true);
        }
      }, 100);

      setTimeout(() => {
        clearInterval(checkInterval);
        reject(new Error("pdfMake โหลดไม่สำเร็จ"));
      }, 10000);
    });
  }

  /**
   * จัดฟอร์แมตตัวเลข
   * @param {number} value
   * @returns {string}
   */
  formatNumber(value) {
    if (!value && value !== 0) return "0.00";
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  /**
   * จัดฟอร์แมตวันที่
   * @param {string} dateString
   * @returns {string}
   */
  formatDate(dateString) {
    if (!dateString) return "";
    if (dateString.includes("/")) {
      return dateString;
    }

    const date = new Date(dateString);
    const day = date
      .getDate()
      .toString()
      .padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  /**
   * สร้างเนื้อหาหลักของ Statement
   * @param {string} documentType - "ORIGINAL" หรือ "COPY"
   * @returns {Array}
   */
  generateMainStatement(documentType = "ORIGINAL") {
    const mainContent = [];
    this.datavote.datavotes = [];
    this.datavote.datanovotes = [];
    this.datavote.options = JSON.parse(this.datavote.options);
    this.datavote.voted = JSON.parse(this.datavote.voted);
    this.datavote.result_most_vote =  this.getTopVotedTexts(this.datavote.options);
    this.datavote.options.filter((x, index) => {
      if(x.votes.length > 0) {
        x.votes.filter(d=>{
          this.datavote.datavotes.push({...d,text:x.text});
        })
      }
    });
    
    if(this.datavote.participants.length > 0 && this.datavote.datavotes.length > 0){
    const participants = this.datavote.participants;
    const users = this.datavote.datavotes;
    const userIdSet = new Set(users.map(u => u.id));
    const result = participants.filter(p => !userIdSet.has(p.user_id));
    this.datavote.datanovotes = result;
}
    
  const chartData = this.prepareChartData(this.datavote.options);
    // ===== หน้าที่ 1 =====
    mainContent.push(
      // Header บริษัท
      {
        columns: [
          {
            width: 100,
            image: this.logoBase64, // ใช้ Base64 ที่โหลดไว้
            fit: [120, 50], 
            alignment: 'center',
            margin: [0, 0, 0, 0],
          },
          {
            width: "*",
            stack: [
              {
                text: "",
                fontSize: 16,
                bold: true,
                margin: [0, 0, 0, 0],
              },
            ],
          },
        ],
        margin: [0, 0, 0, 0],
      },
          {
  stack: [
    {
      text: this.lg_vote_pdf_dialog.title || "",
      fontSize: 20,
      bold: true,
      alignment: 'center',
      margin: [0, -40, 0, 10],
    },
    {
      text: this.datavote.meet_topic || "",
      fontSize: 14,
      bold: true,
      alignment: 'center',
      margin: [0, 0, 0, 5],
    },
        {
      text: this.formatDateTimeGMT(this.datavote.created_at) || "",
      fontSize: 12,
      bold: true,
      colors:'blue',
      alignment: 'center',
      margin: [0, 0, 0, 0],
     color: 'blue',
    },
  ],
  margin: [0, 0, 0, 0],
},

{
  columns: [
    // Total Participants
    {
      width: '*',
      stack: [
        {
          canvas: [
            {
              type: 'rect',
              x: 0,
              y: 0,
              w: 150,
              h: 60,
              r: 8, // border radius
              color: '#ECF0F9', // สีพื้นหลัง (ม่วงอ่อน)
            }
          ]
        },
        {
          columns: [
            {
              width: 50,
              svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>',
              fit: [30, 30],
              margin: [10, -50, 0, 0]
            },
            {
              width: '*',
              stack: [
                {
                  text: 'Total Participants',
                  fontSize: 10,
                  color: '#666666',
                  margin: [0, -50, 0, 2]
                },
                {
                  text: this.datavote.total_participants || '0',
                  fontSize: 20,
                  bold: true,
                  color: '#333333',
                  margin: [0, 0, 0, 0]
                }
              ]
            }
          ],
          margin: [0, 0, 0, 0]
        }
      ],
      margin: [0, 0, 5, 0]
    },
    
    // Total Votes
    {
      width: '*',
      stack: [
        {
          canvas: [
            {
              type: 'rect',
              x: 0,
              y: 0,
              w: 150,
              h: 60,
              r: 8,
              color: '#ECF0F9', // สีพื้นหลัง (เขียวอ่อน)
            }
          ]
        },
        {
          columns: [
            {
              width: 50,
              svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2"><polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>',
              fit: [30, 30],
              margin: [10, -50, 0, 0]
            },
            {
              width: '*',
              stack: [
                {
                  text: 'Total Votes',
                  fontSize: 10,
                  color: '#666666',
                  margin: [0, -50, 0, 2]
                },
                {
                  text: this.datavote.voted.length || '0',
                  fontSize: 20,
                  bold: true,
                  color: '#333333',
                  margin: [0, 0, 0, 0]
                }
              ]
            }
          ],
          margin: [0, 0, 0, 0]
        }
      ],
      margin: [0, 0, 5, 0]
    },
    
    // Participation Rate
    {
      width: '*',
      stack: [
        {
          canvas: [
            {
              type: 'rect',
              x: 0,
              y: 0,
              w: 150,
              h: 60,
              r: 8,
              color: '#ECF0F9', // สีพื้นหลัง (ส้มอ่อน)
            }
          ]
        },
        {
          columns: [
            {
              width: 50,
              svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><circle cx="9.5" cy="9.5" r="1.5"></circle><circle cx="14.5" cy="14.5" r="1.5"></circle></svg>',
              fit: [30, 30],
              margin: [10, -50, 0, 0]
            },
            {
              width: '*',
              stack: [
                {
                  text: 'Participation Rate',
                  fontSize: 10,
                  color: '#666666',
                  margin: [0, -50, 0, 2]
                },
                {
                  text: ( ((this.datavote.voted.length/this.datavote.total_participants)*100).toFixed(1)  || '0.0') + ' %',
                  fontSize: 20,
                  bold: true,
                  color: '#333333',
                  margin: [0, 0, 0, 0]
                }
              ]
            }
          ],
          margin: [0, 0, 0, 0]
        }
      ],
      margin: [0, 0, 0, 0]
    }
  ],
  columnGap: 10,
  margin: [20, 20, 0, 20]
},

//Topic
{
  table: {
    widths: ["100%"],
    body: [
      [{
        stack: [
          {
            canvas: [
              {
                type: 'rect',
                x: 0,
                y: 0,
                w: 480, // ความกว้างเต็ม
                h: 65, // ความสูงของกล่อง
                r: 8, // รัศมีมุมโค้ง
                color: '#ECF0F9',
              }
            ],
          },
          {
            stack: [
              {  
                text: `${this.lg_vote_pdf_dialog.vote_topic} ${this.datavote.question}` || "",
                bold: true,
                fontSize: 12,
                alignment: 'left',
                margin: [0, 0, 0, 5],
              },
              {  
                text: `${this.lg_vote_pdf_dialog.result_most_vote} ${this.datavote.result_most_vote}` || "",
                bold: true,
                fontSize: 12,
                alignment: 'left',
                margin: [0, 0, 0, 0],
              },
            ],
            margin: [15, 0, 15, 15], // margin ข้างใน
            relativePosition: { x: 0, y: -53 }, // ดึงข้อความขึ้นมาทับ canvas
          }
        ],
        border: [false, false, false, false], // ไม่ต้องการเส้นขอบ table
      }]
    ]
  },
  layout: "noBorders",
  margin: [30, 0, 30, 0]
},

// Number of Votes
          {
  stack: [
    {
      text: this.lg_vote_pdf_dialog.number_of_vote,
      fontSize: 12,
      bold: true,
      alignment: 'center',
      margin: [0,0, 0, 0],
    }
  ],
  margin: [0, 0, 0, 0],
},

//กราฟ
   {
        columns: [
          {
            width: 30,
            stack: this.generateYAxisLabels(chartData.values),
            margin: [0, 5, 0, 0]
          },
          {
            width: '*',
            stack: [
              {
                canvas: this.generateBarChartCanvas(chartData.months, chartData.values),
                margin: [0, 0, 0, 5]
              },
              {
                columns: this.generateXAxisLabels(chartData.months, chartData.values),
                margin: [0, 5, 0, 0]
              }
            ]
          }
        ],
        margin: [0, 10, 0,0],
      },

      // ตาราง
      {
      alignment: 'center',
      table: {
        headerRows: 1,
        widths: [230,230],
        body: [
          [
            {
              text: `${this.lg_vote_pdf_dialog.tbl_vote_option}`,
              fontSize: 10,
              bold: true,
              fillColor: "#ECF0F9",
              margin: [5,5,5,5],
            },
            {
              text: `${this.lg_vote_pdf_dialog.tbl_vote_count}`,
              fontSize: 10,
              bold: true,
              fillColor: "#ECF0F9",
              margin: [1,5,1,5],
            },
          ],
          ...this.datavote.options.map((log) => [
            {
              text: `${log.text?log.text:"-"}` || "-",
              fontSize: 9,
              margin: [1,1,1,1],
            },
            {
              text: `${log.count?log.count:"-"}` || "-",
              fontSize: 9,
              margin: [1,1,1,1],
            },
          ]),
        ],
      },
  layout: "noBorders",
  margin:[30,20,30,0],
},


      // ตาราง
      ...(!this.datavote.anonymous && this.datavote.datavotes.length > 0 ? [{
      alignment: 'center',
      table: {
        headerRows: 1,
        widths: [230,230],
        body: [
          [
            {
              text: `${this.lg_vote_pdf_dialog.tbl_participant_name}`,
              fontSize: 10,
              bold: true,
              fillColor: "#ECF0F9",
              margin: [5,5,5,5],
            },
            {
              text: `${this.lg_vote_pdf_dialog.tbl_vote_option}`,
              fontSize: 10,
              bold: true,
              fillColor: "#ECF0F9",
              margin: [1,5,1,5],
            },
          ],
          ...this.datavote.datavotes.map((log) => [
            {
              text: `${log.name?log.name:"-"}` || "-",
              fontSize: 9,
              margin: [1,1,1,1],
            },
            {
              text: `${log.text?log.text:"-"}` || "-",
              fontSize: 9,
              margin: [1,1,1,1],
            },
          ]),
        ],
      },
  layout: "noBorders",
  margin:[30,20,30,0],
}] : []),

          
      // ตาราง
        ...(!this.datavote.anonymous && this.datavote.datanovotes.length > 0 ? [
          {
  stack: [
    {
      text: this.lg_vote_pdf_dialog.participants_who_did_not_vote,
      fontSize: 12,
      bold: true,
      alignment: 'left',
      margin: [30,30, 30, 0],
    }
  ],
  margin: [0, 0, 0, 0],
},
          {
      alignment: 'center',
      table: {
        headerRows: 1,
        widths: [230,230],
        body: [
          [
            {
              text: `${this.lg_vote_pdf_dialog.no}`,
              fontSize: 10,
              bold: true,
              fillColor: "#ECF0F9",
              margin: [5,5,5,5],
            },
            {
              text: `${this.lg_vote_pdf_dialog.tbl_participant_name}`,
              fontSize: 10,
              bold: true,
              fillColor: "#ECF0F9",
              margin: [1,5,1,5],
            },
          ],
          ...this.datavote.datanovotes.map((log,index) => [
            {
              text: `${index+1}` || "-",
              fontSize: 9,
              margin: [1,1,1,1],
            },
            {
              text: `${log.display_name?log.display_name:"-"}` || "-",
              fontSize: 9,
              margin: [1,1,1,1],
            },
          ]),
        ],
      },
  layout: "noBorders",
  margin:[30,20,30,0],
}] : []),

    );

    return mainContent;
  }

  /**
   * สร้างตารางรายการ
   */
  generateItemsTable(items, header, documentType, showcurrencydata) {
    const showcurrency = showcurrencydata;
    return {
      stack: []
    }
  }

  createFooterfirstpage() {
    return {
      stack: [],
      margin: [0, 0, 0, 0],
    }
  }
  
  createFooterotherpage() {
    return {
      stack: [],
      margin: [0, 0, 0, -200]
    };
  }

  /**
   * สร้าง PDF Definition ที่มีทั้ง ORIGINAL และ COPY
   * @returns {Object}
   */
  generateCombinedDocDefinitionForInvoice() {
    const originalContent = this.generateMainStatement("ORIGINAL");

    return {
      pageSize: "A4",
      pageMargins: [25, 25, 25, 50],
      content: [...originalContent],
      header: function(currentPage, pageCount, pageSize) {
        if (currentPage === 1 || currentPage == ((pageCount/2)+1)) {
          // console.log('This is the first page.');
        } else {
          // console.log('This is not the first page. 2+');
        }
      },
      footer: (currentPage, pageCount) => {
        if(currentPage == 1 || currentPage == ((pageCount/2)+1)){
          return {
            stack: [ {
              stack: [
                {
                  text:
                    `© ${new Date().getFullYear()} Dmeets. All rights reserved.`,
                  fontSize: 8,
                  alignment: "left",
                  margin: [25, 5, 25, 1],
                },
                {
                  text:
                    "Generated via Dmeets  —  a secure video meeting platform by Digital Corporate Management Co., Ltd.",
                  fontSize: 8,
                  alignment: "left",
                  margin: [25, 0, 25, 5],
                },
              ],
            },],
            margin: [0, 0, 0, 0],
          };  
        } else {
          return {
            stack: [],
            margin: [0, 0, 0, 0],
          }
        };
      },
      defaultStyle: {
        font: "Sarabun",
        fontSize: 10,
      },
    };
  }
}

// Export instance
export default new PDFInvoiceGenerator();